import React from 'react'
import { useTranslation, formatDateTime, getBase64 } from '../../../constants/helpers'
import { useSearchParams } from 'react-router-dom'
import config from '../../../constants/config'

const PlayersList1 = React.memo(
    ({ id, players, league, size, page, setCheckBox, setIsReady, checkboxPlayer, checkboxStaff, isShowBirthDay, seasonData, teamData, checkboxLeagueName, checkboxSeasonName, sponsorData, isShowSponsor }) => {
        const { t } = useTranslation()
        const [searchParams] = useSearchParams()
        const lang = searchParams.get('local') || 'en'
        const width = size
        const height = width * 1.5
        const [listUser, setListUser] = React.useState([])
        const [playerState, setPlayerState] = React.useState(players || [])
        const px = width / 100
        const playersWrapperWidth = 90 * px
        const listPlayer = playerState.reduce(
            (p, c) => {
                if (!p[c.types]) p[c.types] = []
                if (c.types.length > 1) {
                    p['football_player_type'].push(c)
                    p['football_staff_type'].push(c)
                    return p
                }
                p[c.types].push(c)
                return p
            },
            { football_player_type: [], football_staff_type: [] }
        )

        const arrPriority = ['football_team_manager', 'football_coach', 'football_coach_assistant', 'football_medical_staff', 'football_marketing', 'football_other_staff']
        const maxSortIndex = arrPriority.length
        const _staffs = listPlayer?.football_staff_type
            ?.map(item => {
                const positions = item?.positions
                    ?.map(i => {
                        const sortIndex = arrPriority.findIndex(p => p == i)
                        return { value: i, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
                    })
                    .sort((a, b) => a.sortIndex - b.sortIndex)
                    ?.map(p => p.value)
                const sortIndex = arrPriority?.findIndex(p => p == positions[0])
                return { ...item, positions, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
            })
            .sort((a, b) => a.sortIndex - b.sortIndex)

        React.useEffect(() => {
            setPlayerState(players)
        }, [players])

        React.useEffect(() => {
            setIsReady?.(false)
        }, [playerState])

        React.useEffect(() => {
            setListUser([])
            setCheckBox?.()
        }, [page])

        const onLoaded = value => {
            setListUser(s => [...s, value])
        }

        React.useEffect(() => {
            if (listUser.length === listPlayer?.football_staff_type.length + listPlayer.football_player_type.length) {
                setIsReady?.(true)
            }
        }, [listUser, listPlayer])

        const staffPosition = { football_coach: t('football_coach'), football_coach_assistant: t('football_coach_assistant'), football_marketing: t('football_marketing'), football_medical_staff: t('football_medical_staff'), football_other_staff: t('football_other_staff'), football_team_manager: t('football_team_manager') }
        return (
            <div id={id} style={{ backgroundColor: '#eadadd', minHeight: height, width: width, padding: `${3 * px}px`, borderRadius: `${2 * px}px` }}>
                <div style={{ width: '100%', height: '100%', backgroundColor: '#fff', padding: `${2 * px}px`, borderRadius: `${2 * px}px`, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: `${0.5 * px}px ${0.5 * px}px #921a2a`, border: `${0.2 * px}px solid #921a2a` }}>
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <Image src={seasonData?.logo} style={{ width: `${10 * px}px`, height: `${10 * px}px`, margin: `0px ${px}px` }} />
                            <div style={{ width: `${80 * px}px`, textAlign: 'center', color: '#921a2a' }}>
                                {checkboxLeagueName && <h1 style={{ fontSize: `${2.5 * px}px`, lineHeight: `${3 * px}px`, fontWeight: '600', textTransform: 'uppercase' }}>{league?.name}</h1>}
                                {checkboxSeasonName && <h2 style={{ fontSize: `${2.5 * px}px`, lineHeight: `${3 * px}px`, fontWeight: '600', textTransform: 'uppercase' }}>{seasonData?.name}</h2>}
                                <div style={{ width: '90%', height: '1px', backgroundColor: '#921a2a', margin: '0 auto', marginTop: `${1 * px}px`, marginBottom: `${1 * px}px` }} />
                                <h1 style={{ textAlign: 'center', fontSize: `${2.8 * px}px`, color: '#000', fontWeight: '600', lineHeight: `${3.5 * px}px`, textTransform: 'uppercase' }}>{t('list_team_member')}</h1>
                                <h1 style={{ textAlign: 'center', fontSize: `${2.8 * px}px`, color: '#000', fontWeight: '600', lineHeight: `${3.5 * px}px`, textTransform: 'uppercase' }}>{teamData?.name}</h1>
                            </div>
                            <Image src={teamData?.logo} style={{ width: `${10 * px}px`, height: `${10 * px}px`, margin: `0px ${px}px` }} />
                        </div>
                        {_staffs?.length > 0 && checkboxStaff && (
                            <div style={{ marginTop: `${2 * px}px` }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ backgroundColor: '#921a2a', padding: `${1 * px}px ${1 * px}px ${0.5 * px}px ${0.5 * px}px`, boxShadow: `${0.4 * px}px ${0.4 * px}px #c7c7c7` }}>
                                        <h3 style={{ fontSize: `${2.2 * px}px`, color: '#fff', fontWeight: '600' }}>{t('staff')}</h3>
                                    </div>
                                    <div style={{ width: playersWrapperWidth, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {_staffs?.map((i, idx) => {
                                            const itempx = (width - 10 * px) / 100
                                            return (
                                                <div
                                                    key={`${idx}${i?.id}`}
                                                    style={{
                                                        width: `${32 * itempx}px`,
                                                        marginLeft: [1, 4, 7, 10, 13, 16, 19].includes(idx) ? `${2 * itempx}px` : `0px`,
                                                        marginRight: [1, 4, 7, 10, 13, 16, 19].includes(idx) ? `${2 * itempx}px` : `0px`,
                                                        marginTop: `${2 * itempx}px`,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        border: `${0.5 * itempx}px solid #921a2a`,
                                                        backgroundColor: '#921a2a',
                                                        boxShadow: `${0.4 * itempx}px ${0.4 * itempx}px #c7c7c7`
                                                    }}>
                                                    <Image onload={onLoaded} src={i.avatar} style={{ width: `${((32 * itempx) / 100) * 40}px`, height: `${((32 * itempx) / 100) * 40}px`, objectFit: 'cover' }} />
                                                    <div style={{ width: `${((32 * itempx) / 100) * 60}px`, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center', padding: `${0.1 * itempx}px ${0.3 * itempx}px` }}>
                                                        <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF', fontWeight: '600', textTransform: 'uppercase' }}>{i.name}</h3>
                                                        {isShowBirthDay && <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF', borderTop: `${0.1 * itempx}px solid #fff`, borderBottom: `${0.1 * itempx}px solid #fff` }}>{formatDateTime(i.birthday, 'date')}</h3>}
                                                        <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF' }}>{staffPosition[i.positions[0]] || i?.positions[0]}</h3>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}
                        {listPlayer?.football_player_type?.length > 0 && checkboxPlayer && (
                            <div style={{ marginTop: `${2 * px}px` }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ backgroundColor: '#921a2a', padding: `${1 * px}px ${1 * px}px ${0.5 * px}px ${0.5 * px}px`, boxShadow: `${0.4 * px}px ${0.4 * px}px #c7c7c7` }}>
                                        <h3 style={{ fontSize: `${2.2 * px}px`, color: '#fff', fontWeight: '600' }}>{t('player')}</h3>
                                    </div>
                                    <div style={{ width: playersWrapperWidth, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {listPlayer?.football_player_type?.map((i, idx) => {
                                            const itempx = (width - 10 * px) / 100
                                            return (
                                                <div
                                                    key={`${idx}${i?.id}`}
                                                    style={{
                                                        width: `${32 * itempx}px`,
                                                        marginLeft: [1, 4, 7, 10, 13, 16, 19].includes(idx) ? `${2 * itempx}px` : `0px`,
                                                        marginRight: [1, 4, 7, 10, 13, 16, 19].includes(idx) ? `${2 * itempx}px` : `0px`,
                                                        marginTop: `${2 * itempx}px`,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        border: `${0.5 * itempx}px solid #921a2a`,
                                                        backgroundColor: '#921a2a',
                                                        boxShadow: `${0.4 * itempx}px ${0.4 * itempx}px #c7c7c7`
                                                    }}>
                                                    <Image onload={onLoaded} src={i.avatar} style={{ width: `${((32 * itempx) / 100) * 40}px`, height: `${((32 * itempx) / 100) * 40}px`, objectFit: 'cover' }} />
                                                    <div style={{ width: `${((32 * itempx) / 100) * 60}px`, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center', padding: `${0.1 * itempx}px ${0.3 * itempx}px` }}>
                                                        <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF', fontWeight: '600', textTransform: 'uppercase' }}>{i.name}</h3>
                                                        {isShowBirthDay && <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF', borderTop: `${0.1 * itempx}px solid #fff`, borderBottom: `${0.1 * itempx}px solid #fff` }}>{formatDateTime(i.birthday, 'date')}</h3>}
                                                        <h3 style={{ fontSize: `${2 * itempx}px`, color: '#FFF', fontWeight: '600' }}>
                                                            {t('shirt_number')}: {i.shirtNumber ?? 0}
                                                        </h3>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {isShowSponsor && sponsorData?.length > 0 && (
                        <div style={{ height: `${5 * px}px`, width: '100%', padding: `${0.5 * px}px 0px ${0.5 * px}px 0px`, borderRadius: '50px', marginTop: `${3 * px}px` }}>
                            <div style={{ width: '95%', height: '100%', backgroundColor: '#fff', margin: '0 auto', borderRadius: `${2 * px}px`, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                {sponsorData?.length > 0 && sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ width: `auto`, maxHeight: `${px * 6}px`, backgroundColor: 'white', objectFit: 'cover', marginRight: `${1 * px}px` }} />)}
                            </div>
                        </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: `${0.5 * px}px` }}>
                        <div style={{ fontWeight: '700', fontSize: `${px}px`, color: '#3E3E3E' }}>
                            WWW.VSPORTS.COM.VN
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    (p, n) =>
        JSON.stringify(p.page) === JSON.stringify(n.page) &&
        JSON.stringify(p.players) === JSON.stringify(n.players) &&
        JSON.stringify(p.checkboxLeagueName) === JSON.stringify(n.checkboxLeagueName) &&
        JSON.stringify(p.checkboxSeasonName) === JSON.stringify(n.checkboxSeasonName) &&
        JSON.stringify(p.checkboxPlayer) === JSON.stringify(n.checkboxPlayer) &&
        JSON.stringify(p.checkboxStaff) === JSON.stringify(n.checkboxStaff) &&
        JSON.stringify(p.isShowBirthDay) === JSON.stringify(n.isShowBirthDay) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props?.src?.includes('ui-avatars')) {
            getBase64(config.logo).then(r => {
                setData(r)
            })
        } else {
            getBase64(props.src).then(r => {
                setData(r)
            })
        }
    }, [props.src])
    return data ? <img {...props} src={data} onLoad={props.onload} alt="" /> : null
}

export default PlayersList1
